import { getWorkRequestByReferenceNum, createWorkRequest, updateWorkRequest, findWorkRequests } from './workrequest.action';
import { createWorkItem, executeWorkItems, updateWorkItem, findWorkItems, getWorkItemByReferenceNum, deleteWorkItem, countWorkItems, patchWorkItem } from './workitem.action';
import { createWorkItemActivity, updateWorkItemActivity, removeWorkItemActivity } from './workitem_activity.action';
import { findWorkItemsByAssignee } from './workitem_assignee.action';
import { findInventoryItems } from './inventoryitem.action';
import { uploadMedia } from './media.action';
import { findUsers, getUser, createUser, updateUser, deleteUser, patchUsers, getCurrentUser } from './user.action';
import { findRoles, getRole, createRole, updateRole, deleteRole } from './role.action';
import { findDepartments, getDepartment, createDepartment, updateDepartment, deleteDepartment } from './department.action';
import { findNotifications, createNotification, createNotifications, patchNotification, patchNotifications } from './notification.action';
import { findStaffs } from './staff.action';
import { findPhotos, findPhotosByIds } from './photo.action';
import { findPhotoDocuments, addPhotoDocument, deletePhotoDocument } from './photodocument.action';

export const WorkRequestActionTypes = {
  GET : 'getWorkRequestByReferenceNum',
  CREATE: 'createWorkRequest',
  UPDATE: 'updateWorkRequest',
  FIND: 'findWorkRequests'
};

export const WorkItemActionTypes = {
  GET: 'getWorkItemByReferenceNum',
  CREATE: 'createWorkItem',
  UPDATE: 'updateWorkItems',
  PATCH: 'patchWorkItems',
  FIND: 'findWorkItems',
  EXECUTE_MULTIPLE: 'executeWorkItems',
  COMMENT: 'createWorkItemActivity',
  COMMENT_UPDATE: 'updateWorkItemActivity',
  COMMENT_DELETE: 'removeWorkItemActivity',
  DELETE: 'deleteWorkItem',
  FIND_BY_ASSIGNEE: 'findWorkItemsByAssignee',
  COUNT: 'countWorkItems'
};

export const InventoryItemActionTypes = {
  FIND: 'findInventoryItems'
};

export const MediaActionTypes = {
  UPLOAD: 'uploadMeda'
};

export const NotificationActionTypes = {
  CREATE: 'createNotification',
  PATCH: 'patchNotification',
  PATCH_MULTIPLE: 'patchNotifications',
  FIND: 'findNotifications'
};

export const UserActionTypes = {
  FIND: 'findUsers',
  GET : 'getUser',
  CREATE: 'createUser',
  UPDATE: 'updateUser',
  DELETE: 'deleteUser',
  PATCH_MULTIPLE: 'patchUsers',
  GET_CURRENT: 'getCurrentUser'
};

export const RoleActionTypes = {
  FIND: 'findRoles',
  GET : 'getRole',
  CREATE: 'createRole',
  UPDATE: 'updateRole',
  DELETE: 'deleteRole'
};

export const DepartmentActionTypes = {
  FIND: 'findDepartments',
  GET : 'getDepartment',
  CREATE: 'createDepartment',
  UPDATE: 'updateDepartment',
  DELETE: 'deleteDepartment'
};

export const StaffActionTypes = {
  FIND: 'findStaffs'
};

export const PhotoActionTypes = {
  FIND: 'findPhotos',
  FINDBYID: 'findPhotosByIds'
};

export const PhotoDocumentActionTypes = {
  FIND: 'findPhotoDocuments',
  CREATE: 'createPhotoDocument',
  DELETE: 'deletePhotoDocument',
};

export {
  getWorkRequestByReferenceNum,
  findInventoryItems,
  uploadMedia,
  createWorkRequest,
  getWorkItemByReferenceNum,
  createWorkItem,
  executeWorkItems,
  findWorkItems,
  updateWorkItem,
  patchWorkItem,
  deleteWorkItem,
  countWorkItems,
  updateWorkRequest,
  findWorkItemsByAssignee,
  findWorkRequests,
  findUsers,
  getUser,
  getCurrentUser,
  createUser,
  updateUser,
  deleteUser,
  patchUsers,
  findRoles,
  getRole,
  createRole,
  updateRole,
  deleteRole,
  findDepartments,
  getDepartment,
  createDepartment,
  updateDepartment,
  deleteDepartment,
  createWorkItemActivity,
  updateWorkItemActivity,
  removeWorkItemActivity,
  findNotifications,
  createNotification,
  createNotifications,
  patchNotification,
  patchNotifications,
  findStaffs,
  findPhotos,
  findPhotosByIds,
  findPhotoDocuments,
  addPhotoDocument,
  deletePhotoDocument,
};



// WEBPACK FOOTER //
// ./src/actions/index.js